<template>
  <div>
    <!-- Aggregation Method Selector for Numeric Data -->
    <div class="px-2 pb-2" v-if="resultType === 'number'">
      <label class="font-weight-bold small mb-1">Aggregation</label>
      <b-button-group class="d-flex" size="sm">
        <b-button
          :variant="
            aggregationNumeric === 'total' ? 'primary' : 'outline-primary'
          "
          @click="LOCATION_SET_AGGREGATION_NUMERIC('total')"
        >
          Total
        </b-button>
        <b-button
          :variant="
            aggregationNumeric === 'avg' ? 'primary' : 'outline-primary'
          "
          @click="LOCATION_SET_AGGREGATION_NUMERIC('avg')"
        >
          Avg
        </b-button>
        <b-button
          :variant="
            aggregationNumeric === 'median' ? 'primary' : 'outline-primary'
          "
          @click="LOCATION_SET_AGGREGATION_NUMERIC('median')"
        >
          Median
        </b-button>
        <b-button
          :variant="
            aggregationNumeric === 'most_recent' ? 'primary' : 'outline-primary'
          "
          @click="LOCATION_SET_AGGREGATION_NUMERIC('most_recent')"
        >
          Recent
        </b-button>
      </b-button-group>
    </div>

    <!-- Aggregation Method Selector for Categorical Data -->
    <div
      class="px-2 pb-2"
      v-if="resultType === 'dropdown' || resultType === 'radio'"
    >
      <label class="font-weight-bold small mb-1">Display</label>
      <b-button-group class="d-flex" size="sm">
        <b-button
          :variant="
            aggregationCategorical === 'most_frequent'
              ? 'primary'
              : 'outline-primary'
          "
          @click="LOCATION_SET_AGGREGATION_CATEGORICAL('most_frequent')"
        >
          Most Frequent
        </b-button>
        <b-button
          :variant="
            aggregationCategorical === 'most_recent'
              ? 'primary'
              : 'outline-primary'
          "
          @click="LOCATION_SET_AGGREGATION_CATEGORICAL('most_recent')"
        >
          Most Recent
        </b-button>
      </b-button-group>
    </div>

    <!-- Aggregation Method Selector for Datasheet Usage -->
    <div class="px-2 pb-2" v-if="resultType === 'datasheet_usage'">
      <label class="font-weight-bold small mb-1">Display</label>
      <b-button-group class="d-flex" size="sm">
        <b-button
          :variant="
            aggregationDatasheetUsage === 'most_frequent'
              ? 'primary'
              : 'outline-primary'
          "
          @click="LOCATION_SET_AGGREGATION_DATASHEET_USAGE('most_frequent')"
        >
          Most Frequent
        </b-button>
        <b-button
          :variant="
            aggregationDatasheetUsage === 'most_recent'
              ? 'primary'
              : 'outline-primary'
          "
          @click="LOCATION_SET_AGGREGATION_DATASHEET_USAGE('most_recent')"
        >
          Most Recent
        </b-button>
      </b-button-group>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "MapAggregationPicker",

  computed: {
    ...mapState({
      resultType: (state) => state.project.map.resultType,
      aggregationNumeric: (state) => state.project.map.aggregationNumeric,
      aggregationCategorical: (state) =>
        state.project.map.aggregationCategorical,
      aggregationDatasheetUsage: (state) =>
        state.project.map.aggregationDatasheetUsage,
    }),
  },

  methods: {
    ...mapMutations({
      LOCATION_SET_AGGREGATION_NUMERIC:
        "project/map/LOCATION_SET_AGGREGATION_NUMERIC",
      LOCATION_SET_AGGREGATION_CATEGORICAL:
        "project/map/LOCATION_SET_AGGREGATION_CATEGORICAL",
      LOCATION_SET_AGGREGATION_DATASHEET_USAGE:
        "project/map/LOCATION_SET_AGGREGATION_DATASHEET_USAGE",
    }),
  },
};
</script>
